module.exports = __webpack_public_path__ + "static/media/cardback1.a1dc3476.jpg";